(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  function initTabs(){
    const tabs=document.getElementById('ims-wh-tabs');
    if(!tabs)return;
    tabs.querySelectorAll('.ims__tab').forEach(tab=>{
      tab.addEventListener('click',()=>{
        tabs.querySelectorAll('.ims__tab').forEach(t=>t.classList.remove('ims__tab--active'));
        tab.classList.add('ims__tab--active');
        loadTab(tab.dataset.tab);
      });
    });
  }
 
  function loadTab(tab){
    switch(tab){
      case 'overview': loadOverview(); break;
      case 'transfers': loadTransfers(); break;
      case 'receiving': loadReceiving(); break;
      case 'picking': loadPicking(); break;
      case 'cycle': loadCycleCounting(); break;
    }
  }

  // ─── OVERVIEW ───────────────────────────────────────────────────
  async function loadOverview(){
    const content=document.getElementById('ims-wh-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const {data:whs}=await db().select('warehouses');
    // cost_price does not exist on products table — select only available columns
    const {data:stock}=await db().select('stock_levels',{select:'quantity,reserved_qty,warehouse_id,products(name,sku,reorder_threshold)',noCompanyFilter:true});
    const warehouses=whs||[], stockLevels=stock||[];
    if(!warehouses.length){
      content.innerHTML=`<div class="ims__coming-soon"><i class="ti ti-building-warehouse"></i><h3>No warehouses configured</h3><p>Add your first warehouse to start tracking stock.</p><button class="ims__btn ims__btn--primary" style="margin-top:16px" onclick="window.IMS_WAREHOUSE.showNewWarehouse()"><i class="ti ti-plus"></i> Add warehouse</button></div>`;
      return;
    }
    content.innerHTML=`
      <div style="display:flex;justify-content:flex-end;margin-bottom:14px">
        <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_WAREHOUSE.showNewWarehouse()"><i class="ti ti-plus"></i> Add warehouse</button>
      </div>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px">
        ${warehouses.map(wh=>{
          const whStock=stockLevels.filter(s=>s.warehouse_id===wh.id);
          const totalUnits=whStock.reduce((sum,s)=>sum+(s.quantity||0),0);
          const lowCount=whStock.filter(s=>s.quantity<=(s.products?.reorder_threshold||10)&&s.quantity>0).length;
          const outCount=whStock.filter(s=>s.quantity<=0&&s.products).length;
          return `<div class="ims__card">
            <div class="ims__card-header">
              <div class="ims__card-title"><i class="ti ti-building-warehouse"></i>${util().sanitize(wh.name)}</div>
              <span class="ims__pill ims__pill--${wh.is_active?'success':'neutral'}">${wh.is_active?'Active':'Inactive'}</span>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:12px">
              <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Products</div><div class="ims__stat-value" style="font-size:20px">${whStock.length}</div></div>
              <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total units</div><div class="ims__stat-value" style="font-size:20px">${totalUnits}</div></div>
              <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Low/Out</div><div class="ims__stat-value ims__stat-value--${(lowCount+outCount)>0?'danger':'success'}" style="font-size:20px">${lowCount+outCount}</div></div>
            </div>
            ${wh.address?`<div style="font-size:12px;color:var(--ims-text-muted);margin-bottom:8px">${util().sanitize(wh.address)}</div>`:''}
            <div class="ims__btn-group">
              <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_WAREHOUSE.viewStock('${wh.id}','${util().sanitize(wh.name)}')"><i class="ti ti-list"></i> View stock</button>
<button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_WAREHOUSE.editWarehouse('${wh.id}')" title="Edit warehouse"><i class="ti ti-edit"></i></button>            </div>
          </div>`;
        }).join('')}
      </div>`;
  }

  async function viewStock(warehouseId,warehouseName){
    // cost_price does not exist on products table — removed from select
    const {data:stock}=await db().select('stock_levels',{select:'quantity,reserved_qty,bin_reference,products(id,name,sku,reorder_threshold)',eq:{warehouse_id:warehouseId},noCompanyFilter:true});
    const items=(stock||[]).sort((a,b)=>(a.products?.name||'').localeCompare(b.products?.name||''));
    ui().openModal(`Stock: ${warehouseName}`,`
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>SKU</th><th>Product</th><th>Bin</th><th>On hand</th><th>Reserved</th><th>Available</th><th>Status</th></tr></thead>
          <tbody>${items.map(s=>{
            const avail=(s.quantity||0)-(s.reserved_qty||0);
            const st=s.quantity<=0?'danger':s.quantity<=(s.products?.reorder_threshold||10)?'warning':'success';
            return `<tr><td>${util().sanitize(s.products?.sku||'—')}</td><td>${util().sanitize(s.products?.name||'—')}</td><td>${util().sanitize(s.bin_reference||'—')}</td><td>${s.quantity||0}</td><td>${s.reserved_qty||0}</td><td style="font-weight:600">${avail}</td><td><span class="ims__pill ims__pill--${st}">${s.quantity<=0?'Out':s.quantity<=(s.products?.reorder_threshold||10)?'Low':'OK'}</span></td></tr>`;
          }).join('')||'<tr><td colspan="7" class="ims__table-empty">No stock recorded</td></tr>'}
          </tbody>
        </table>
      </div>
    `,`<button class="ims__btn ims__btn--primary" onclick="window.SM.UI.closeModal()">Close</button>`,'lg');
  }

  // ─── TRANSFERS ──────────────────────────────────────────────────
  async function loadTransfers(){
    const content=document.getElementById('ims-wh-content');
    if(!content)return;
    const {data:movements}=await db().select('stock_movements',{select:'*, products(name,sku), warehouses(name), users(name)',eq:{movement_type:'transfer_in'},order:{col:'created_at',asc:false},limit:50});
    const items=movements||[];
    content.innerHTML=`
      <div style="display:flex;justify-content:flex-end;margin-bottom:14px">
        <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.showTransferForm()"><i class="ti ti-arrows-transfer-up"></i> New transfer</button>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Date</th><th>Product</th><th>SKU</th><th>Qty</th><th>To warehouse</th><th>Reference</th><th>By</th></tr></thead>
            <tbody>${items.map(m=>`<tr>
              <td>${util().formatDate(m.created_at)}</td>
              <td>${util().sanitize(m.products?.name||'—')}</td>
              <td>${util().sanitize(m.products?.sku||'—')}</td>
              <td>${m.quantity}</td>
              <td>${util().sanitize(m.warehouses?.name||'—')}</td>
              <td>${util().sanitize(m.reference||'—')}</td>
              <td>${util().sanitize(m.users?.name||'—')}</td>
            </tr>`).join('')||'<tr><td colspan="7" class="ims__table-empty">No transfers yet</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  async function showTransferForm(){
    const {data:whs}=await db().select('warehouses',{eq:{is_active:true}});
    const {data:products}=await db().select('products',{order:{col:'name'},select:'id,name,sku'});
    const whOpts=(whs||[]).map(w=>`<option value="${w.id}">${util().sanitize(w.name)}</option>`).join('');
    const prodOpts=(products||[]).map(p=>`<option value="${p.id}">${util().sanitize(p.name)} (${p.sku})</option>`).join('');
    ui().openModal('Stock transfer',`
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Product</label><select class="ims__select" id="ims-tr-product"><option value="">Select product</option>${prodOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">From warehouse</label><select class="ims__select" id="ims-tr-from"><option value="">Select source</option>${whOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">To warehouse</label><select class="ims__select" id="ims-tr-to"><option value="">Select destination</option>${whOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Quantity</label><input class="ims__input" type="number" min="1" id="ims-tr-qty" placeholder="Units to transfer"></div>
        <div class="ims__form-group"><label class="ims__label">Reference</label><input class="ims__input" type="text" id="ims-tr-ref" placeholder="Transfer reference"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Reason</label><textarea class="ims__textarea" id="ims-tr-reason" rows="2" placeholder="Reason for transfer"></textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.confirmTransfer()"><i class="ti ti-check"></i> Confirm transfer</button>
    `,'sm');
  }

  async function confirmTransfer(){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const productId=g('ims-tr-product'),fromId=g('ims-tr-from'),toId=g('ims-tr-to');
    const qty=parseInt(g('ims-tr-qty')),ref=g('ims-tr-ref'),reason=g('ims-tr-reason');
    if(!productId){ui().toast('Please select a product','error');return;}
    if(!fromId||!toId){ui().toast('Please select source and destination','error');return;}
    if(fromId===toId){ui().toast('Source and destination must be different','error');return;}
    if(!qty||qty<1){ui().toast('Please enter a valid quantity','error');return;}
    if(!reason){ui().toast('Please enter a reason','error');return;}
    const {data:fromStock}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:fromId},maybeSingle:true,noCompanyFilter:true});
    if(!fromStock||fromStock.quantity<qty){ui().toast('Insufficient stock in source warehouse','error');return;}
    await db().update('stock_levels',fromStock.id,{quantity:fromStock.quantity-qty,last_updated:new Date().toISOString()});
    const {data:toStock}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:toId},maybeSingle:true,noCompanyFilter:true});
    if(toStock){await db().update('stock_levels',toStock.id,{quantity:toStock.quantity+qty,last_updated:new Date().toISOString()});}
    else{await db().insert('stock_levels',{product_id:productId,warehouse_id:toId,quantity:qty,reserved_qty:0});}
    await db().insert('stock_movements',{product_id:productId,warehouse_id:fromId,movement_type:'transfer_out',quantity:-qty,reference:ref||null,reason,user_id:window.SM.AUTH.user?.id});
    await db().insert('stock_movements',{product_id:productId,warehouse_id:toId,movement_type:'transfer_in',quantity:qty,reference:ref||null,reason,user_id:window.SM.AUTH.user?.id});
    ui().closeModal();ui().toast(`${qty} units transferred successfully`,'success');loadOverview();
  }

  // ─── RECEIVING ──────────────────────────────────────────────────
  async function loadReceiving(){
    const content=document.getElementById('ims-wh-content');
    if(!content)return;
    const {data:pos}=await db().select('purchase_orders',{select:'id,po_number,status,suppliers(name),expected_delivery',eq:{status:'sent'},order:{col:'created_at',asc:false}});
    const items=pos||[];
    content.innerHTML=`
      <div class="ims__card">
        <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-package-import"></i>Pending goods receiving</div></div>
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>PO Number</th><th>Supplier</th><th>Expected</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>${items.map(po=>`<tr>
              <td class="ims__link">${util().sanitize(po.po_number)}</td>
              <td>${util().sanitize(po.suppliers?.name||'—')}</td>
              <td>${po.expected_delivery?util().formatDate(po.expected_delivery):'—'}</td>
              <td>${util().pill(po.status)}</td>
              <td><button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_PURCHASES.receiveGoods('${po.id}')"><i class="ti ti-package-import"></i> Receive</button></td>
            </tr>`).join('')||'<tr><td colspan="5" class="ims__table-empty">No pending deliveries</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  // ─── PICKING ────────────────────────────────────────────────────
  async function loadPicking(){
    const content=document.getElementById('ims-wh-content');
    if(!content)return;
    const {data:orders}=await db().select('orders',{select:'id,order_number,customer_name,status,created_at,order_items(quantity,product_name,sku,products(name,sku,default_bin))',eq:{status:'confirmed'},order:{col:'created_at'}});
    const items=orders||[];
    content.innerHTML=`
      <div class="ims__card">
        <div class="ims__card-header">
          <div class="ims__card-title"><i class="ti ti-clipboard-list"></i>Orders ready to pick (${items.length})</div>
          ${items.length?`<button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_WAREHOUSE.printAllPicking()"><i class="ti ti-printer"></i> Print all</button>`:''}
        </div>
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Order #</th><th>Customer</th><th>Items</th><th>Date</th><th>Actions</th></tr></thead>
            <tbody>${items.map(o=>`<tr>
              <td class="ims__link">${util().sanitize(o.order_number)}</td>
              <td>${util().sanitize(o.customer_name||'—')}</td>
              <td>${(o.order_items||[]).length}</td>
              <td>${util().formatDate(o.created_at)}</td>
              <td><div class="ims__btn-group">
                <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_WAREHOUSE.printPickingList('${o.id}')"><i class="ti ti-printer"></i> Print</button>
                <button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_WAREHOUSE.startPicking('${o.id}')"><i class="ti ti-check"></i> Start picking</button>
              </div></td>
            </tr>`).join('')||'<tr><td colspan="5" class="ims__table-empty">No orders awaiting picking</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  async function startPicking(orderId){
    await db().update('orders',orderId,{status:'picking'});
    ui().toast('Order marked as picking','success');loadPicking();
  }

  async function printPickingList(orderId){
    const {data:order}=await db().select('orders',{select:'*, order_items(quantity,product_name,sku,products(name,sku,default_bin))',eq:{id:orderId},maybeSingle:true,noCompanyFilter:true});
    if(!order)return;

    const infoRows=[
      ['Customer', util().sanitize(order.customer_name||'—')],
      ['Address', util().sanitize(order.address||'—')],
      ['Date', util().formatDate(order.created_at)]
    ];
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(order.order_items||[]).map(i=>[
      util().sanitize(i.product_name||i.products?.name||'—'),
      util().sanitize(i.sku||i.products?.sku||'—'),
      `<span style="color:#2563EB;font-weight:600">${util().sanitize(i.products?.default_bin||'—')}</span>`,
      `<strong>${i.quantity}</strong>`,
      '&nbsp;',
      '&nbsp;'
    ]);
    const itemTableHtml=window.PRINT.table({
      colWidths:['28%','16%','16%','14%','13%','13%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Default bin'},
        {label:'Qty required'},{label:'Qty picked'},{label:'Sign'}
      ],
      rows:itemRows
    });

    const headerHtml=window.PRINT.header({
      title:'Picking List',
      docRef:order.order_number
    });

    const sigFooterHtml=`
      <div style="margin-top:20px;display:flex;gap:40px;align-items:center;font-size:9pt">
        <div>Picked by: ${window.PRINT.signatureBox(140)}</div>
        <div>Date/Time: ${window.PRINT.signatureBox(140)}</div>
        <div>Checked by: ${window.PRINT.signatureBox(140)}</div>
      </div>`;

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Items to pick</div>
      <hr class="rule">
      ${itemTableHtml}
      ${sigFooterHtml}
    `;

    window.PRINT.renderDocument([page],`Picking List: ${order.order_number}`);
  }

  async function printAllPicking(){
    const {data:orders}=await db().select('orders',{
      select:'order_number,customer_name,address,created_at,order_items(quantity,product_name,sku,products(name,sku,default_bin))',
      eq:{status:'confirmed'},order:{col:'created_at'}
    });
    if(!orders?.length){ui().toast('No orders to print','warning');return;}

    const pages=orders.map(o=>{
      const infoRows=[
        ['Customer', util().sanitize(o.customer_name||'—')],
        ['Address', util().sanitize(o.address||'—')]
      ];
      const infoTableHtml=window.PRINT.table({
        colWidths:['30%','70%'],
        columns:[{label:'Field'},{label:'Value'}],
        rows:infoRows
      });

      const itemRows=(o.order_items||[]).map(i=>[
        util().sanitize(i.product_name||i.products?.name||'—'),
        util().sanitize(i.sku||i.products?.sku||'—'),
        `<span style="color:#2563EB;font-weight:600">${util().sanitize(i.products?.default_bin||'—')}</span>`,
        `<strong>${i.quantity}</strong>`,
        '&nbsp;',
        '&nbsp;'
      ]);
      const itemTableHtml=window.PRINT.table({
        colWidths:['28%','16%','16%','14%','13%','13%'],
        columns:[
          {label:'Product'},{label:'SKU'},{label:'Bin'},
          {label:'Required'},{label:'Picked'},{label:'Sign'}
        ],
        rows:itemRows
      });

      const headerHtml=window.PRINT.header({
        title:'Picking List',
        docRef:o.order_number
      });

      return `
        ${headerHtml}
        <hr class="rule">
        ${infoTableHtml}
        <div class="st" style="margin-top:14px">Items to pick</div>
        <hr class="rule">
        ${itemTableHtml}
      `;
    });

    window.PRINT.renderDocument(pages,`All picking lists — ${new Date().toLocaleDateString('en-GB')}`);
  }

  // ─── CYCLE COUNTING ─────────────────────────────────────────────
  async function loadCycleCounting(){
    const content=document.getElementById('ims-wh-content');
    if(!content)return;
    const {data:counts}=await db().select('cycle_counts',{select:'*, warehouses(name), users(name)',order:{col:'created_at',asc:false},limit:20});
    const items=counts||[];
    content.innerHTML=`
      <div style="display:flex;justify-content:flex-end;margin-bottom:14px">
        <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.startCycleCount()"><i class="ti ti-plus"></i> New cycle count</button>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Count #</th><th>Date</th><th>Warehouse</th><th>Class</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>${items.map(c=>`<tr>
              <td>${util().sanitize(c.count_number)}</td>
              <td>${util().formatDate(c.count_date)}</td>
              <td>${util().sanitize(c.warehouses?.name||'—')}</td>
              <td>${c.product_class||'All'}</td>
              <td>${util().pill(c.status)}</td>
              <td><div class="ims__btn-group">
                ${c.status==='pending'?`<button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_WAREHOUSE.openCycleCount('${c.id}')"><i class="ti ti-edit"></i> Enter counts</button>`:''}
                <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_WAREHOUSE.printCycleSheet('${c.id}')"><i class="ti ti-printer"></i></button>
              </div></td>
            </tr>`).join('')||'<tr><td colspan="6" class="ims__table-empty">No cycle counts yet</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  async function startCycleCount(){
    const {data:whs}=await db().select('warehouses',{eq:{is_active:true}});
    const whOpts=(whs||[]).map(w=>`<option value="${w.id}">${util().sanitize(w.name)}</option>`).join('');
    ui().openModal('New cycle count',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Warehouse</label><select class="ims__select" id="ims-cc-wh"><option value="">Select warehouse</option>${whOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label">Product class</label>
          <select class="ims__select" id="ims-cc-class">
            <option value="all">All products</option>
            <option value="A">Class A (fast-moving)</option>
            <option value="B">Class B (medium)</option>
            <option value="C">Class C (slow-moving)</option>
          </select></div>
        <div class="ims__form-group"><label class="ims__label">Count date</label><input class="ims__input" type="date" id="ims-cc-date" value="${new Date().toISOString().split('T')[0]}"></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.createCycleCount()"><i class="ti ti-check"></i> Create count sheet</button>
    `,'sm');
  }

  async function createCycleCount(){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const warehouseId=g('ims-cc-wh'), productClass=g('ims-cc-class'), countDate=g('ims-cc-date');
    if(!warehouseId){ui().toast('Please select a warehouse','error');return;}
    const {data:lastCC}=await db().select('cycle_counts',{select:'count_number',order:{col:'created_at',asc:false},limit:1});
    const countNumber=util().generateRef('CC',lastCC?.[0]?.count_number);
    const {data:count,error}=await db().insert('cycle_counts',{count_number:countNumber,warehouse_id:warehouseId,product_class:productClass||'all',count_date:countDate||new Date().toISOString().split('T')[0],status:'pending',created_by:window.SM.AUTH.user?.id});
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    // Create count items from stock levels
    const {data:stock}=await db().select('stock_levels',{select:'quantity,product_id,bin_reference',eq:{warehouse_id:warehouseId},noCompanyFilter:true});
    if(stock?.length){
      const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
      await Promise.all((stock||[]).map(s=>client.from('cycle_count_items').insert({cycle_count_id:count.id,product_id:s.product_id,warehouse_id:warehouseId,bin_reference:s.bin_reference,expected_qty:s.quantity,status:'pending'})));
    }
    ui().closeModal();ui().toast(`Cycle count ${countNumber} created`,'success');loadCycleCounting();
  }

  async function printCycleSheet(countId){
    const {data:count}=await db().select('cycle_counts',{select:'*, warehouses(name), cycle_count_items(expected_qty,bin_reference,products(name,sku))',eq:{id:countId},maybeSingle:true,noCompanyFilter:true});
    if(!count)return;

    const infoRows=[
      ['Warehouse', util().sanitize(count.warehouses?.name||'—')],
      ['Date', util().formatDate(count.count_date)],
      ['Class', util().sanitize(count.product_class||'All')]
    ];
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(count.cycle_count_items||[]).map(i=>[
      util().sanitize(i.products?.name||'—'),
      util().sanitize(i.products?.sku||'—'),
      util().sanitize(i.bin_reference||'—'),
      String(i.expected_qty||0),
      '&nbsp;',
      '&nbsp;',
      '&nbsp;'
    ]);
    const itemTableHtml=window.PRINT.table({
      colWidths:['24%','14%','14%','12%','12%','12%','12%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Bin'},{label:'System qty'},
        {label:'Actual count'},{label:'Variance'},{label:'Sign'}
      ],
      rows:itemRows
    });

    const headerHtml=window.PRINT.header({
      title:'Cycle Count Sheet',
      docRef:count.count_number
    });

    const sigFooterHtml=`
      <div style="margin-top:20px;display:flex;gap:40px;align-items:center;font-size:9pt">
        <div>Counted by: ${window.PRINT.signatureBox(140)}</div>
        <div>Date: ${window.PRINT.signatureBox(140)}</div>
        <div>Signature: ${window.PRINT.signatureBox(140)}</div>
      </div>`;

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Products to count</div>
      <hr class="rule">
      ${itemTableHtml}
      ${sigFooterHtml}
    `;

    window.PRINT.renderDocument([page],`Cycle Count Sheet: ${count.count_number}`);
  }

  async function openCycleCount(countId){
    const {data:count}=await db().select('cycle_counts',{
      select:'*, warehouses(name), cycle_count_items(id,expected_qty,counted_qty,bin_reference,products(name,sku))',
      eq:{id:countId},maybeSingle:true,noCompanyFilter:true
    });
    if(!count)return;
    const items=count.cycle_count_items||[];
    ui().openModal(`Enter cycle count: ${count.count_number}`,`
      <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
        <span>Enter actual counts from your printed count sheet. Variances are highlighted automatically.</span>
      </div>
      <div class="ims__table-wrap" style="margin-top:12px">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Bin</th><th>System qty</th><th>Actual count</th><th>Variance</th></tr></thead>
          <tbody>${items.map((item,i)=>`<tr>
            <td>${util().sanitize(item.products?.name||'—')}</td>
            <td>${util().sanitize(item.products?.sku||'—')}</td>
            <td>${util().sanitize(item.bin_reference||'—')}</td>
            <td style="font-weight:600">${item.expected_qty||0}</td>
            <td>
              <input class="ims__input" type="number" min="0"
                id="ims-cc-qty-${i}"
                data-item-id="${item.id}"
                data-expected="${item.expected_qty||0}"
                value="${item.counted_qty!==null?item.counted_qty:''}"
                placeholder="Enter count"
                style="width:90px"
                oninput="window.IMS_WAREHOUSE.showVariance(${i})">
            </td>
            <td id="ims-cc-var-${i}" style="font-weight:600"></td>
          </tr>`).join('')||'<tr><td colspan="6" class="ims__table-empty">No items in this count</td></tr>'}
          </tbody>
        </table>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--secondary" onclick="window.IMS_WAREHOUSE.saveCycleCount('${countId}',${items.length},false)"><i class="ti ti-device-floppy"></i> Save draft</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.saveCycleCount('${countId}',${items.length},true)"><i class="ti ti-check"></i> Confirm &amp; adjust stock</button>
    `,'xl');
    // Show existing variances
    items.forEach((_,i)=>window.IMS_WAREHOUSE.showVariance(i));
  }

  function showVariance(i){
    const input=document.getElementById(`ims-cc-qty-${i}`);
    const varEl=document.getElementById(`ims-cc-var-${i}`);
    if(!input||!varEl)return;
    const val=input.value.trim();
    if(val===''){varEl.textContent='';return;}
    const counted=parseInt(val)||0;
    const expected=parseInt(input.dataset.expected)||0;
    const variance=counted-expected;
    if(variance===0){varEl.textContent='✓';varEl.style.color='var(--ims-success)';}
    else{varEl.textContent=`${variance>0?'+':''}${variance}`;varEl.style.color=variance<0?'var(--ims-danger)':'var(--ims-success)';}
  }

  async function saveCycleCount(countId,itemCount,confirm_adjust){
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    let hasVariance=false;
    for(let i=0;i<itemCount;i++){
      const input=document.getElementById(`ims-cc-qty-${i}`);
      if(!input||input.value.trim()==='')continue;
      const counted=parseInt(input.value)||0;
      const expected=parseInt(input.dataset.expected)||0;
      const variance=counted-expected;
      if(variance!==0)hasVariance=true;
      await client.from('cycle_count_items').update({
        counted_qty:counted,variance,status:confirm_adjust?'adjusted':'counted'
      }).eq('id',input.dataset.itemId);
      // If confirming — adjust stock levels
      if(confirm_adjust&&variance!==0){
        const {data:cc}=await client.from('cycle_count_items').select('product_id,warehouse_id').eq('id',input.dataset.itemId).single();
        if(cc?.product_id&&cc?.warehouse_id){
          const {data:sl}=await db().select('stock_levels',{eq:{product_id:cc.product_id,warehouse_id:cc.warehouse_id},maybeSingle:true,noCompanyFilter:true});
          if(sl){
            await db().update('stock_levels',sl.id,{quantity:counted,last_updated:new Date().toISOString()});
            await db().insert('stock_movements',{product_id:cc.product_id,warehouse_id:cc.warehouse_id,movement_type:'cycle_count',quantity:variance,reference:`CC-${countId}`,reason:'Cycle count adjustment',user_id:window.SM.AUTH.user?.id});
          }
        }
      }
    }
    if(confirm_adjust){
      await client.from('cycle_counts').update({status:'completed',completed_at:new Date().toISOString()}).eq('id',countId);
      ui().closeModal();
      ui().toast(`Cycle count completed${hasVariance?' — stock adjusted':''}. All variances logged.`,'success',5000);
    } else {
      ui().closeModal();
      ui().toast('Cycle count saved as draft','success');
    }
    loadCycleCounting();
  }

  // ─── WAREHOUSE FORM ─────────────────────────────────────────────
  async function editWarehouse(id){
    const {data:wh}=await db().select('warehouses',{eq:{id},maybeSingle:true,noCompanyFilter:true});
    if(!wh)return;
    ui().openModal(`Edit warehouse: ${util().sanitize(wh.name)}`,`
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full">
          <label class="ims__label ims__label--req">Warehouse name</label>
          <input class="ims__input" type="text" id="ims-wh-edit-name" value="${util().sanitize(wh.name||'')}">
        </div>
        <div class="ims__form-group ims__form-group--full">
          <label class="ims__label">Address</label>
          <textarea class="ims__textarea" id="ims-wh-edit-address" rows="2">${util().sanitize(wh.address||'')}</textarea>
        </div>
        <div class="ims__form-group">
          <label class="ims__label">Contact name</label>
          <input class="ims__input" type="text" id="ims-wh-edit-contact" value="${util().sanitize(wh.contact_name||'')}">
        </div>
        <div class="ims__form-group">
          <label class="ims__label">Contact phone</label>
          <input class="ims__input" type="tel" id="ims-wh-edit-phone" value="${util().sanitize(wh.contact_phone||'')}">
        </div>
        <div class="ims__form-group">
          <label class="ims__label">Contact email</label>
          <input class="ims__input" type="email" id="ims-wh-edit-email" value="${util().sanitize(wh.contact_email||'')}">
        </div>
        <div class="ims__form-group">
          <label class="ims__label">Status</label>
          <select class="ims__select" id="ims-wh-edit-active">
            <option value="true" ${wh.is_active?'selected':''}>Active</option>
            <option value="false" ${!wh.is_active?'selected':''}>Inactive</option>
          </select>
        </div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.saveEditWarehouse('${id}')"><i class="ti ti-check"></i> Save changes</button>
    `,'sm');
  }

  async function saveEditWarehouse(id){
    const name=document.getElementById('ims-wh-edit-name')?.value?.trim();
    const address=document.getElementById('ims-wh-edit-address')?.value?.trim();
    const contact_name=document.getElementById('ims-wh-edit-contact')?.value?.trim();
    const contact_phone=document.getElementById('ims-wh-edit-phone')?.value?.trim();
    const contact_email=document.getElementById('ims-wh-edit-email')?.value?.trim();
    const isActive=document.getElementById('ims-wh-edit-active')?.value==='true';
    if(!name){ui().toast('Warehouse name is required','error');return;}
    const {data:existingList}=await db().select('warehouses',{eq:{name},noCompanyFilter:true});
    if(existingList?.some(w=>w.id!==id)){ui().toast(`A warehouse named "${name}" already exists`,'error');return;}
    const {error}=await db().update('warehouses',id,{
      name,
      address:address||null,
      contact_name:contact_name||null,
      contact_phone:contact_phone||null,
      contact_email:contact_email||null,
      is_active:isActive
    });
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    ui().closeModal();ui().toast('Warehouse updated','success');loadOverview();
  }

  function showNewWarehouse(){
    ui().openModal('Add warehouse',`
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Warehouse name</label><input class="ims__input" type="text" id="ims-wh-name" placeholder="e.g. Main Warehouse, London Hub"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Address</label><textarea class="ims__textarea" id="ims-wh-address" rows="2"></textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_WAREHOUSE.saveWarehouse()"><i class="ti ti-check"></i> Save</button>
    `,'sm');
  }

  async function saveWarehouse(){
    const name=document.getElementById('ims-wh-name')?.value?.trim();
    const address=document.getElementById('ims-wh-address')?.value?.trim();
    if(!name){ui().toast('Warehouse name is required','error');return;}
    const {data:existingList}=await db().select('warehouses',{eq:{name},noCompanyFilter:true});
    if(existingList?.length){ui().toast(`A warehouse named "${name}" already exists`,'error');return;}
    const {error}=await db().insert('warehouses',{name,address:address||null});
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    ui().closeModal();ui().toast('Warehouse added','success');loadOverview();
  }

  window.addEventListener('ims:panel',e=>{
    if(e.detail.panel==='warehouse'){initTabs();loadOverview();}
  });
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-wh-transfer-btn')?.addEventListener('click',showTransferForm);
  });

  window.IMS_WAREHOUSE={load:loadOverview,loadTab,loadOverview,viewStock,loadTransfers,showTransferForm,confirmTransfer,loadReceiving,loadPicking,startPicking,printPickingList,printAllPicking,loadCycleCounting,startCycleCount,createCycleCount,printCycleSheet,openCycleCount,showVariance,saveCycleCount,showNewWarehouse,saveWarehouse,editWarehouse,saveEditWarehouse};
})();
